import { action, json } from "@solidjs/router";
import { _putWhitelistNumber, _removeWhitelistNumber } from "../roma-api/sms";
import { getSMSNumbers } from "./";

export const deleteWhitelistNumberAction = action(async (id: string) => {
  const response = await _removeWhitelistNumber(id);

  return json(response, { revalidate: getSMSNumbers.key });
});
